import { createFileRoute } from "@tanstack/react-router";
import { GlobalNotesPage } from "@/components/notes/NotesPages";

/** /notes: global notes (facts across products, e.g. the port registry). */
export const Route = createFileRoute("/_app/notes/")({ component: () => <GlobalNotesPage /> });
